import React from 'react'
import styled from '@emotion/styled'
import { Outlet } from 'react-router-dom'

const style = {
  backgroundImage: 'url(/img/others/img-17.jpg)',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
}

const AuthContainer = styled.div(() => ({
  height: '100%',
}))

const AuthWrapper = styled.div(() => ({
  minHeight: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}))

export const AuthLayout = () => {
  return (
    <AuthContainer>
      <AuthWrapper style={style}>
        <Outlet />
      </AuthWrapper>
    </AuthContainer>
  )
}

export default AuthLayout
